import React, { Component } from 'react';
import './../css/master.css';
import './../css/stock.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';

var httpURL = '';
var queryString = require('querystring');
var lstStock	= [];

class Stock extends Component {
  constructor(props){
	super(props);
	this.state={
		designImagePath : require('./../images/blank.png'),
		loader:'none',
		opacity:1,
		stock:0,
		width1:'97%',
	}
  }
  
    async componentWillUnmount() {
        await localStorage.removeItem('stock');
    }

  async componentDidMount(){
	var detail = await localStorage.getItem('stock');
	var details = JSON.parse(detail);
	$('#ipoId').val(details.ipoId);
	$('#ipoNo').val(details.ipoNo);
	$('#bpoId').val(details.bpoId);
	$('#bpoNo').val(details.bpoNo);
	$('#ipoDesignId').val(details.ipoDesignId);
	$('#designId').val(details.designId);
	$('#designNoColor').val(details.designNoColor);
	$('#bpoStyleId').val(details.bpoStyleId);
	$('#styleColor').val(details.style+'-'+details.color);
	$('#quality').val(details.quality);
	$('#length').val(details.length);
	$('#width').val(details.width);
	$('#yarnCount').val(details.yarnCount);
	$('#construction').val(details.construction);
	
	this.setState({loader:'block', opacity:0.5, designImagePath:details.imageUrl});  
	await axiosInstance.get(httpURL+'/a/mst/sto/list',{
		withCredentials: true
	}).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			lstStock = response.data.lstStockLocation;
			this.fillStockCmb();
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	}); 
  	
	axiosInstance.post(httpURL+'/a/ipo/liststock',
	  queryString.stringify({'ipoDesignId':$('#ipoDesignId').val()}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			$('#stockLocationCmb').val(response.data.stock.stockLocationId);
			$('#bookedStock').val(response.data.stock.stockBooked);
			$('#folioNo').val(response.data.stock.folioNo);
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }
  
  fillStockCmb=()=>{
	$('#stockLocationCmb').empty();
	$('#stockLocationCmb').prepend($('<option> </option>').val(0).html('Stock Location'));
	for(var i=0; i<lstStock.length; i++){
		var stockLocationId = lstStock[i].stockLocationId;
		var stockLocation = lstStock[i].stockLocation;
		$('#stockLocationCmb').append($('<option> </option>').val(stockLocationId).html(stockLocation));
	}  
  }

  saveStock=()=>{
	var stock = {};
	var ipoDesignId = $('#ipoDesignId').val();
	var stockBooked = $("#bookedStock").val();
	var folioNo = $("#folioNo").val();
	var stockLocationId = $("#stockLocationCmb").find('option:selected').val();
	if(stockBooked == ''){
		toast.warning('Please fill booked stock quantity');
		return false;
	}

	if(stockLocationId == 0){
		toast.warning('Please select stock location');
		return false;
	}
	stock = {ipoDesignId, stockBooked, stockLocationId,folioNo};
	this.setState({loader:'block', opacity:0.5});
	
	axiosInstance.post(httpURL+'/a/ipo/savestock',
	  queryString.stringify({'stock':JSON.stringify(stock)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

 render() {
	httpURL = window.httpURL;  
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader, zIndex:9999}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div>
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-9 col-centered">
						<div className="col-sm-12">
							<div className="styleBackground" style={{padding:15}}>
								<form className="form-inline">
									<div className="form-group">
										<label style={{width:100}} htmlFor="ipoNo">IPO NO:</label>
										<input style={{display:'none'}} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
										<input style={{display:'none'}} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
										<input style={{marginLeft:2}} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
									</div>
									<div className="form-group">
										<label style={{marginLeft:10, width:100}} htmlFor="bpoNo">BPO NO:</label>
										<input style={{display:'none'}} placeholder="BPO Id" type="text" className="form-control" id="bpoId" />
										<input style={{marginLeft:2}} readOnly placeholder="BPO Number" type="text" className="form-control" id="bpoNo" />
									</div>
									<div className="form-group">
										<label style={{marginLeft:10, width:100}} htmlFor="designNoColor">Design Color:</label>
										<input style={{display:'none'}} placeholder="Design Id" type="text" className="form-control" id="designId" />
										<input style={{marginLeft:2}} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
									</div>
								</form>
								<form className="form-inline" style={{marginTop:5}}>
									<div className="form-group">
										<label style={{width:100}} htmlFor="quality">Quality:</label>
										<input style={{marginLeft:2}} readOnly placeholder="Quality" type="text" className="form-control" id="quality" />
									</div>
									<div className="form-group">
										<label style={{marginLeft:10, width:100}} htmlFor="length">Length:</label>
										<input style={{marginLeft:2}} readOnly placeholder="Length" type="text" className="form-control text-right" id="length" />
									</div>
									<div className="form-group">
										<label style={{marginLeft:10, width:100}} htmlFor="width">Width:</label>
										<input style={{marginLeft:2}} readOnly placeholder="Width" type="text" className="form-control" id="width" />
									</div>
								</form>
								<form className="form-inline" style={{marginTop:5}}>	
									<div className="form-group">
										<label style={{width:100}} htmlFor="yarnCount">Yarn Count:</label>
										<input style={{marginLeft:2}} readOnly placeholder="Yarn Count" type="text" className="form-control" id="yarnCount" />
									</div>
									<div className="form-group">
										<label style={{marginLeft:10, width:100}} htmlFor="construction">Construction:</label>
										<input style={{marginLeft:2}} readOnly placeholder="Construction" type="text" className="form-control" id="construction" />
									</div>
									<div className="form-group">
										<label style={{marginLeft:10, width:100}} htmlFor="styleColor">Style-Color:</label>
										<input style={{display:'none'}} placeholder="Style Id" type="text" className="form-control" id="bpoStyleId" />
										<input style={{marginLeft:2}} readOnly placeholder="Style-Color" type="text" className="form-control" id="styleColor" />
									</div>
								</form>
							</div>
							<div className="row" style={{marginTop:20}}>
								<div className="col-sm-8">
									<form className="form-horizontal styleBackground" style={{padding:'30px 80px'}}>
										<div className="form-group">
											<label htmlFor="bookedStock" className="control-label col-sm-4">Booked Stock:</label>
											<div className="col-sm-8">
												<input type="text" className="form-control text-right" id="bookedStock" placeholder="Booked Stock" />
											</div>
										</div>
										<div className="form-group">
											<label htmlFor="stockLocationCmb" className="control-label col-sm-4">Stock Location:</label>
											<div className="col-sm-8">
												<select className="form-control" id="stockLocationCmb"></select>
											</div>
										</div>
										<div className="form-group">
											<label htmlFor="Folio Number" className="control-label col-sm-4">Folio Number:</label>
											<div className="col-sm-8">
												<input type="text" className="form-control text-right" id="folioNo" placeholder="Folio Number" />
											</div>
										</div>
										<div className="form-group text-center" style={{marginTop:50}}>
											<button type="button" onClick={this.saveStock} className="btn btn-warning">Save</button>
										</div>
									</form>
								</div>
								<div className="col-sm-4">
									<div className="pull-right" id="designColorImageDivStock">
										<ReactImageMagnify {...{
											smallImage: {
													alt: 'Design Image',
													src: this.state.designImagePath,
													isFluidWidth: true,
											},
											largeImage: {
													src: this.state.designImagePath,
													width: 600,
													height: 900
											},
											enlargedImageContainerDimensions:{
												width:300,
												height:300,
											},
											enlargedImageContainerStyle:{
												left:-312,
												top:0,
											},
										}} />
									</div>
								</div>	
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Stock;
